import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Save hours every week', 'Create content faster', 'Stop overthinking', 'Work smarter', 'Get better AI responses', 'Reduce mental overload', 'Increase productivity', 'Organize your workflow'];
export function BenefitsSection() {
  return <section className="py-32 bg-black-charcoal border-y border-white/5" data-id="element-67">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-68">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-69">
          <div data-id="element-70">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-71">
              The Outcome
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite leading-[1.05] mb-8 tracking-tight" data-id="element-72">
              Work smarter. <br data-id="element-73" />
              <span className="text-gold" data-id="element-74">Reclaim your time.</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl text-muted leading-relaxed max-w-lg" data-id="element-75">
              This isn't just a list of prompts. It's a complete operating
              system designed to remove friction from your daily tasks and
              elevate your output.
            </motion.p>
          </div>

          <div className="bg-black-light border border-white/5 rounded-2xl p-8 md:p-12" data-id="element-76">
            <ul className="space-y-6" data-id="element-77">
              {benefits.map((benefit, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center gap-4 text-lg text-offwhite" data-id="element-78">
                  <CheckCircle2Icon className="w-6 h-6 text-gold shrink-0" data-id="element-79" />
                  <span data-id="element-80">{benefit}</span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}